import { ExternalLink, Page } from "../components/ui.jsx";
import { OPS } from "../data/ops.js";
import { DREAM_TEAMS } from "../data/dreamteam.js";
import { rankOf } from "../data/levels.js";

// `team` comes from the session — it's derived from Planning Center Services
// team membership at sign-in, same fetch that decides the tier.
export default function Ops({ back, go, userRank, team }) {
  const isLeader = userRank >= rankOf("leader");
  const isDirector = userRank >= rankOf("director");

  const iconFor = (name) => (DREAM_TEAMS.find((t) => t.name === name) || {}).icon || "📂";

  return (
    <Page back={back} eyebrow="Run the House" title="SOPs & Playbooks." intro={OPS.intro}>
      {team && OPS.teamFolders[team] && (
        <ExternalLink
          id={OPS.teamFolders[team]}
          className="card ops-mine"
        >
          <div className="name">
            <span className="lead">
              <span>{iconFor(team)}</span>
              <span>Your team: {team}</span>
            </span>
            <span className="badge">Open</span>
          </div>
          <div className="desc" style={{ color: "#0F0F0F" }}>
            Everything your team runs on Sunday — checklists, how-tos, run of show.
          </div>
        </ExternalLink>
      )}

      {!team && !isLeader && (
        <div className="card">
          <div className="name">
            <span>📂 Your team's playbook lands here</span>
          </div>
          <div className="desc">
            We look up your serving team from Planning Center. Not seeing yours? Ask your
            leader to add you to the team in Planning Center Services — it appears here
            automatically.
          </div>
        </div>
      )}

      {/* The photography SOP is a page in here rather than a document in Drive,
          so it links inward. Open to everyone, like the page itself. */}
      {go && (
        <>
          <div className="block">
            <h3>🎨 Creative</h3>
            <p>The photography SOP and shot menu, with the reference frames behind it.</p>
          </div>
          <button className="card" onClick={() => go("creative")}>
            <div className="name">
              <span className="lead">
                <span>📸</span>
                <span>Sundays Are Festival — Photo SOP</span>
              </span>
              <span className="arrow">→</span>
            </div>
            <div className="desc">
              The four promises, the Smile Mandate, the full shot menu, and 110 reference
              frames with a note on why each one works.
            </div>
          </button>
        </>
      )}

      {isLeader && (
        <>
          <div className="block">
            <h3>📂 Every team's playbook</h3>
            <p>Leaders see the whole shelf.</p>
          </div>
          {Object.entries(OPS.teamFolders).map(([name, url]) => (
            <ExternalLink key={name} id={url}>
              <div className="name">
                <span className="lead">
                  <span>{iconFor(name)}</span>
                  <span>{name}</span>
                </span>
                <span className="arrow">→</span>
              </div>
            </ExternalLink>
          ))}
        </>
      )}

      {isDirector && (
        <>
          <div className="block" style={{ marginTop: 28 }}>
            <h3>🏛️ Run the whole house</h3>
            <p>Director-level operations.</p>
          </div>
          {OPS.breakouts.map((b) => (
            <ExternalLink key={b.name} id={b.url}>
              <div className="name">
                <span className="lead">
                  <span>{b.icon}</span>
                  <span>{b.name}</span>
                </span>
                <span className="arrow">→</span>
              </div>
              <div className="desc">{b.desc}</div>
            </ExternalLink>
          ))}
        </>
      )}

      <div className="privacy-note">
        House rule: if you do a task more than twice, write it down and file it here.
        Future you says thank you.
      </div>
    </Page>
  );
}
